var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTypeFormUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "68px",
    viewBox: "0 0 92 68",
    width: "92px",
    style: {
      display: "block"
    },
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46 .64a27.9 27.9 0 0 1 19.78 8.19 27.78 27.78 0 0 1 8.03 20A19.95 19.95 0 0 1 92 48.63c0 11.04-8.97 20-20 20H23c-12.67 0-23-10.33-23-23a22.94 22.94 0 0 1 18.63-22.46 27.79 27.79 0 0 1 7.56-14.34A27.97 27.97 0 0 1 46 .63zm0 6c-5.64 0-11.26 2.1-15.56 6.4-3.66 3.66-5.96 10.59-6.51 15.34 0 .06.2.06-2.5.32A17.02 17.02 0 0 0 6 45.64c0 9.42 7.58 17 17 17h49c7.8 0 14-6.2 14-14 0-7.81-6.2-14-14-14H67.12v-3.36c0-10.7-1.43-14.1-5.59-18.24-4.32-4.3-9.9-6.4-15.53-6.4z",
    fill: "rgba(146, 0, 26, 0.3)",
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(32,15)",
    d: "M13 .53l-2.03 1.89-11 10 4.06 4.44L10 11.42v19.22h6V11.42l5.97 5.44c.03.02 4.06-4.44 4.06-4.44l-11-10c-.4-.36-1.07-1-2.03-1.9z",
    fill: "rgba(146, 0, 26, 0.3)",
    fillRule: "nonzero"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeFormUpload);
export default __webpack_public_path__ + "static/media/typeFormUpload.428a54c339dbeaa6587382d7adff9104.svg";
export { ForwardRef as ReactComponent };